import { ArrowLeft, ArrowRight } from 'lucide-react'
import type Opportunity from '@/types/serializers/Opportunity'
import type { NavigationData } from '@/types/NavigationData'

interface PageHeaderProps {
    opportunity: Opportunity
    onBack: () => void
    onNextOpportunity: () => void
    navigationData: NavigationData
}

export default function PageHeader({opportunity, onBack, onNextOpportunity, navigationData}: PageHeaderProps) {
    return (
        <div className="flex items-center justify-between mb-4">
            <div className="flex-1">
                <div className="flex items-center space-x-4 mb-2">
                    <button
                        onClick={onBack}
                        className="flex items-center space-x-2 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white"
                    >
                        <ArrowLeft className="w-4 h-4"/>
                        <span>Back</span>
                    </button>
                </div>
                <div className="text-sm text-slate-500 dark:text-slate-400 mb-1">
                    {opportunity.account?.name || 'Unknown Company'}
                </div>
                <h1 className="text-2xl font-bold text-slate-900 dark:text-white">
                    {opportunity.title || 'Untitled Opportunity'}
                </h1>
                <div className="text-sm text-slate-500 dark:text-slate-400">
                    Last updated {new Date(opportunity.updated_at).toLocaleDateString()}
                </div>
            </div>

            <div className="flex items-center space-x-4">
                <div
                    className="text-sm text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-dark-bg-400 px-3 py-1 rounded-full">
                    {navigationData.position}/{navigationData.total}
                </div>
                <button
                    onClick={onNextOpportunity}
                    disabled={!navigationData.next_opportunity_path}
                    className="flex items-center space-x-2 bg-accent text-white px-4 py-2 rounded-lg hover:bg-accent/90 transition-colors disabled:bg-slate-300 disabled:cursor-not-allowed disabled:hover:bg-slate-300"
                >
                    <span>Next Opportunity</span>
                    <ArrowRight className="w-4 h-4"/>
                </button>
            </div>
        </div>
    )
}